import Glide from '@glidejs/glide'
import { CanSlide } from '../utils/_glide-plugins'
import { debounce } from '../utils/_debounce'

const $ = jQuery

export default function EmployeeSlider () {
  const WRAPPER = document.getElementById('mtt-employees')
  if (!WRAPPER) return

  const SLIDER = new EmployeeGlide(WRAPPER)
}

class EmployeeGlide {
  constructor (wrapper) {
    this.WRAPPER = wrapper
    this.BREAKPOINT = 1160
    this.SELECTOR_EL = this.WRAPPER.querySelector('.glide')
    this.TOGGLES = this.WRAPPER.querySelectorAll('.mtt-employees__toggle')
    this.LOADER = this.WRAPPER.querySelector('.mtt-employees__loader')
    this.SWIPE_ICONS = this.WRAPPER.querySelectorAll('.swipe-icon')

    this.icons_hidden = false
    this.slider_init = false

    this.initSlider()
  }

  sliderEventListeners () {
    // hide icons on swipe start
    console.log('hideeee')
    this.SLIDER.on('swipe.start', this.hideSwipeIcons.bind(this))
  }

  initSlider () {
    this.BREAKPOINT >= this.getScreenWidth() ? this.createSlider() : ''
    window.addEventListener('resize', debounce(() => {
      this.BREAKPOINT >= this.getScreenWidth() ? this.createSlider() : this.destroySlider()
    }, 300))
  }

  createSlider () {
    if (this.slider_init) {
      return
    }

    // init slider
    this.SLIDER = new Glide(this.SELECTOR_EL, {
      type: 'slider',
      startAt: 0,
      perView: 1,
      gap: 56,
      animationDuration: 700,
      keyboard: false,
      bound: true,
      rewind: false,
      dragThreshold: 30,
      swipeThreshold: 50,
      peek: { before: 0, after: 0 },
      breakpoints: {
        1160: {
          gap: 56,
          peek: { before: 0, after: 400 }
        },
        1000: {
          gap: 56,
          peek: { before: 0, after: 300 }
        },
        900: {
          gap: 40,
          peek: { before: 0, after: 230 }
        },
        800: {
          gap: 56,
          peek: { before: 0, after: 150 }
        },
        750: {
          gap: 56,
          peek: { before: 0, after: 0 }
        }
      }
    })

    // mount slider
    this.SLIDER.mount({ CanSlide })

    // update var
    this.slider_init = true

    // init slide events
    this.sliderEventListeners()
  }

  destroySlider () {
    if (!this.slider_init) {
      return
    }

    this.SLIDER.destroy()

    this.slider_init = false
  }

  hideSwipeIcons () {
    if (!this.DIST && !this.SWIPE_ICONS.length && this.icons_hidden) {
      return
    }

    for (let i = 0; i < this.SWIPE_ICONS.length; i++) {
      this.SWIPE_ICONS[i].classList.add('swipe-icon--hide')
    }

    this.icons_hidden = true
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}
